import { useContext } from 'react';
import SnackbarContext from '../Snackbar/SnackbarContext';

let globalNotificationHandler: ((message: string, isError?: boolean, isSticky?: boolean) => void) | null = null;

export const setGlobalNotificationHandler = (
  handler: (message: string, isError?: boolean, isSticky?: boolean) => void
) => {
  globalNotificationHandler = handler;
};

export const showNotification = (message: string, isError = false, isSticky = false): void => {
  if (globalNotificationHandler) {
    globalNotificationHandler(message, isError, isSticky);
  } else if (isError) {
      console.error(message);
    } else {
      console.log(message);
    }
};

export const useNotification = () => {
  const snackbarContext = useContext(SnackbarContext);

  return {
    showNotification: (message: string, isError = false, isSticky = false) => {
      snackbarContext.addMessage(message, isError, isSticky);
    }
  };
};